<div>
    <div class="main-content">
        <header class="top-header">
            <h3>Add Bridge</h3>
        </header>

        <form class="form" [formGroup]="bridgeForm" (ngSubmit)="onSubmit()">
            <div class="form-row">
                <div class="form-group">
                    <label>Organization Name <small>*</small></label>
                    <input formControlName="organization" readonly/>
                </div>
                <div class="form-group">
                    <label>Bridge Name <small>*</small></label>
                    <input type="text" placeholder="Bridge Name" formControlName="bridgeName"/>
                    <div class="error"
                         *ngIf="bridgeForm.get('bridgeName')?.invalid && bridgeForm.get('bridgeName')?.touched">
                        <small *ngIf="bridgeForm.get('bridgeName')?.errors?.['required']">Bridge Name is
                            required.</small>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label>Bridge ESN <small>*</small></label>
                    <input type="text" placeholder="Bridge ESN" formControlName="bridgeEsn"
                           (input)="onEsnInput($event)"/>
                    <div class="error"
                         *ngIf="bridgeForm.get('bridgeEsn')?.invalid && bridgeForm.get('bridgeEsn')?.touched">
                        <small *ngIf="bridgeForm.get('bridgeEsn')?.errors?.['required']">Bridge ESN is
                            required.</small>
                    </div>
                </div>
                <div class="form-group">
                    <label>Serial Number <small>*</small></label>
                    <input type="text" placeholder="Serial Number" formControlName="serialNumber"
                           (input)="onSerialNumberInput($event)"/>
                    <div class="error"
                         *ngIf="bridgeForm.get('serialNumber')?.invalid && bridgeForm.get('serialNumber')?.touched">
                        <small *ngIf="bridgeForm.get('serialNumber')?.errors?.['required']">Serial Number is
                            required.</small>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label>Bridge Type <small>*</small></label>
                    <select formControlName="bridgeType" id="bridgeType">
                        <option value="" disabled>Select bridge type</option>
                        <option *ngFor="let option of bridgeTypes" [value]="option.value">{{ option.label }}</option>
                    </select>
                    <div class="error"
                         *ngIf="bridgeForm.get('bridgeType')?.invalid && bridgeForm.get('bridgeType')?.touched">
                        <small *ngIf="bridgeForm.get('bridgeType')?.errors?.['required']">Bridge Type is
                            required.</small>
                    </div>
                </div>
            </div>

            <div class="button-row">
                <button class="btn-save" type="submit">
                    <fa-icon [icon]="['fas', 'square-plus']" style="padding-right: 3px;"></fa-icon>
                    ADD
                </button>
                <button class="btn-cancel" type="button" (click)="onCancel()">
                    <fa-icon [icon]="['fas', 'square-xmark']" style="padding-right: 3px;"></fa-icon>
                    Cancel
                </button>
            </div>
        </form>
    </div>
</div>

<div *ngIf="showSuccessModal" class="confirmation-modal">
    <div class="modal-content success-modal-content">
        <header class="top-header modal-header">
            <h3>Bridge Created Successfully</h3>
            <p>Save this key securely. It will not be fully shown again.</p>
        </header>

        <div class="generated-key-box">{{ generatedRawKey }}</div>

        <div class="button-row">
            <app-copy-button [value]="generatedRawKey" copyTitle="Copy API key"></app-copy-button>
            <button class="btn-cancel" type="button" (click)="closeSuccessModal()">
                <fa-icon [icon]="['fas', 'square-xmark']" style="padding-right: 3px;"></fa-icon>
                Close
            </button>
        </div>
    </div>
</div>
